import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';

export class EventAggregationService {
	public static get instance(): IEventAggregationService | null {
		if (window.EventAggregationService) {
			return window.EventAggregationService;
		}

		return null;
	}
}
